import { render, staticRenderFns } from "./dictionary-field.vue?vue&type=template&id=544af55e&scoped=true&"
import script from "./dictionary-field.vue?vue&type=script&lang=js&"
export * from "./dictionary-field.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-field.vue?vue&type=style&index=0&id=544af55e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544af55e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VTextField})
